import { c as _c } from "react/compiler-runtime";
import { Logger } from '@onefootprint/logger';
import type React from 'react';
import { useEffect } from 'react';
import useSession, { type OrgSession, type UserSession } from '@/hooks/use-session';
type DatadogReplayProviderProps = {
  children: React.ReactNode;
};
const DatadogReplayProvider = t0 => {
  const $ = _c(8);
  const {
    children
  } = t0;
  const session = useSession();
  const shouldRecord = _temp;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (user_0, org) => {
      Logger.setUser({
        id: user_0.id,
        name: user_0.firstName || "",
        email: user_0.email
      });
      Logger.appendGlobalContext({
        tenant_id: org.id,
        tenant_name: org.name
      });
      if (!shouldRecord(user_0)) {
        return;
      }
      Logger.startSessionReplay();
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const initReplay = t1;
  const stopReplay = _temp2;
  let t2;
  if ($[1] !== session.data.org || $[2] !== session.data.user) {
    t2 = () => {
      if (session.data.user && session.data.org) {
        initReplay(session.data.user, session.data.org);
      } else {
        stopReplay();
      }
    };
    $[1] = session.data.org;
    $[2] = session.data.user;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = session.data.user?.id;
  const t4 = session.data.org?.id;
  let t5;
  if ($[4] !== session.isLoggedIn || $[5] !== t3 || $[6] !== t4) {
    t5 = [session.isLoggedIn, t3, t4];
    $[4] = session.isLoggedIn;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  useEffect(t2, t5);
  return children;
};
export default DatadogReplayProvider;
function _temp(user) {
  return !user.isFirmEmployee;
}
function _temp2() {
  Logger.stopSessionReplay();
  Logger.clearUser();
  Logger.removeGlobalContext(["tenant_id", "tenant_name"]);
}